var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { GUTTER, gridWidth } from '../../../utilities/grid';
import { media } from '../../../utilities/media';
import { RowWrapper } from './RowWrapper';
const LayoutDiv = styled.div `
  width: 100%;
  ${media.tablet `
    ${({ paddingTop }) => paddingTop ? `padding-top:${parseInt(paddingTop)}px;` : ''}
    max-width: ${({ width }) => gridWidth['tablet'](parseInt(width))}px;
  `};
`;
export class Layout extends React.PureComponent {
    render() {
        const _a = this.props, { children } = _a, props = __rest(_a, ["children"]);
        return (React.createElement(LayoutDiv, Object.assign({}, props),
            React.createElement(RowWrapper, Object.assign({}, props), children)));
    }
}
Layout.defaultProps = {
    width: 12,
    mode: 'grid',
    paddingTop: 40,
    gutter: GUTTER['tablet'],
};
//# sourceMappingURL=index.js.map